import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import { visitorIdInsidePercentile } from 'helpers/visitorId';
var FS_SDK_JS = "window._fs_debug = false;\nwindow._fs_host = 'www.fullstory.com';\nwindow._fs_org = '174QC';\n(function(m,n,e,t,l,o,g,y){\n  g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];\n  o=n.createElement(t);o.async=1;o.src='https://'+_fs_host+'/s/fs.js';\n  y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);\n  g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v)};g.setUserVars=function(v){FS(l,v)};\n  g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;FS(o,v)};\n  g.clearUserCookie=function(d,i){d=n.domain;while(1){n.cookie='fs_uid=;domain='+d+\n  ';path=/;expires='+new Date(0);i=d.indexOf('.');if(i<0)break;d=d.slice(i+1)}}\n})(window,document,'FS','script','user');";
var DEFAULT_SAMPLE_SIZE = 0.1;
var ELEVATED_SAMPLE_SIZE = 0.33;
var ELEVATED_PATHS = ['live$', 'live/', 'videos$', 'videos/', 'search$', 'search/'];
var ELEVATED_PATH_REGEX = new RegExp("^/(?:".concat(ELEVATED_PATHS.join('|'), ")"));
export var FullStorySDK =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FullStorySDK, _React$Component);

  function FullStorySDK() {
    _classCallCheck(this, FullStorySDK);

    return _possibleConstructorReturn(this, _getPrototypeOf(FullStorySDK).apply(this, arguments));
  }

  _createClass(FullStorySDK, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.currentUser && !this.props.currentUser && this.fs()) {
        this.fs().identify(String(nextProps.currentUser.id), {
          email: nextProps.currentUser.email
        });
      }

      return false;
    }
  }, {
    key: "getSampleSizeForPath",
    value: function getSampleSizeForPath(path) {
      return ELEVATED_PATH_REGEX.test(path) ? ELEVATED_SAMPLE_SIZE : DEFAULT_SAMPLE_SIZE;
    }
    /* istanbul ignore next */

  }, {
    key: "fs",
    value: function fs() {
      return window.fs;
    }
  }, {
    key: "useFullStory",
    value: function useFullStory() {
      var _this$props = this.props,
          currentPath = _this$props.currentPath,
          visitorId = _this$props.visitorId;
      var sampleSize = this.getSampleSizeForPath(currentPath);
      return visitorIdInsidePercentile(visitorId, 0.0, sampleSize) && (!__LOCAL_DEV__ || __TEST__);
    }
  }, {
    key: "render",
    value: function render() {
      var currentUser = this.props.currentUser;

      if (!this.useFullStory()) {
        return false;
      }

      var userSetJs;

      if (currentUser) {
        userSetJs = "FS.identify(\"".concat(currentUser.id, "\", {\n        email: ").concat(JSON.stringify(currentUser.email), "\n      });");
      }

      return React.createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: (FS_SDK_JS + userSetJs).replace(/\n/g, '')
        }
      });
    }
  }]);

  return FullStorySDK;
}(React.Component);
FullStorySDK.propTypes = {
  currentUser: PropTypes.object,
  currentPath: PropTypes.string.isRequired,
  visitorId: PropTypes.string
};